<script lang="ts" setup>

  type Props = {
    golfs: { id: number, name: string }[]
    title: string
  }

  const props = defineProps<Props>()
  const emit = defineEmits<{
    (e: 'on-golf-click', id: number): void
  }>()

  const search = ref('')

  const filteredGolfs = computed((): { id: number, name: string }[] => {
    const regex = new RegExp(`${search.value}`, 'gi')
    const sanitizeString = (str: string) => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    return search.value ? props.golfs.filter((g) => regex.test(sanitizeString(g.name))) : props.golfs
  })

</script>

<template>
  <div class="c-product-golf-list">
    <div class="title">
      {{ title }}
    </div>
    <div class="search">
      <InputBase
        v-model="search"
        name="search"
        class="input"
        type="text"
        :resetable="true"
        :placeholder="$t('navigation.search')"
      />
    </div>
    <div class="list">
      <div
        v-for="(golf, index) in filteredGolfs"
        :key="`golf-link-${index}`"
        class="item"
      >
        <span class="icon">
          <SvgIcon
            icon="location"
            :height="18"
          />
        </span>
        <span class="name">
          <span @click="emit('on-golf-click', golf.id)">{{ golf.name }}</span>
        </span>
      </div>
      <NoResult
        v-if="filteredGolfs.length === 0"
        @display-all="search = ''"
      />
    </div>
  </div>
</template>
<style scoped>

.c-product-golf-list {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  padding: 0 1em;
  overflow-y: hidden;

  .c-no-result{
    margin-top: 2em;
  }

  .title {
    color: var(--color-secondary);
    font-family: Bariol, sans-serif;
    font-size: 2.5em;
    font-weight: 600;
  }

  .search {
    margin: 1em 0;
  }

  .list {
    position: relative;
    margin-top: 1em;
    overflow-y: scroll;

    .item {
      display: flex;
      align-items: center;
      margin-top: 0.5em;
      color: var(--color-secondary);
      cursor: pointer;
      font-family: Open-Sans, sans-serif;
      font-size: 1.125em;
      font-weight: 400;
      opacity: 0.8;

      &:hover {
        opacity: 1;
      }

      .icon {
        margin-right: 0.5em;
      }
    }
  }
}
</style>
